module.exports = __webpack_public_path__ + "img/seal.187127f5.svg";